import { connect } from "react-redux";
import { mapStateToProps, mapDispatchToProps } from "./Clients.state";
import ClientsForm from "./ClientsForm";
import Navigation from "../../components/navigation";
import React from "react";
import { Pages, ReduxFreeformActions } from "../../types";
import { Title } from "@thecb/components";

interface Props {
  actions: {
    forms: {
      clientsForm: {
        actions: ReduxFreeformActions;
      };
    };
  };
}

const ClientsPage = ({ actions }: Props) => {
  return (
    <>
      <Title as="h1" weight="bold">
        Cashiering Client Settings
      </Title>
      <Navigation page={Pages.CLIENT_SETTINGS} />
      <ClientsForm formActions={actions.forms.clientsForm.actions} />
    </>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(ClientsPage);
